import type { Column } from "@silevis/reactgrid";
import type { ParticipantListRequiredFields } from "./participantListApi";

export function getColumns(requiredFields: ParticipantListRequiredFields, availableWidth: number = 1750): Column[] {
  const divideBy = 3 + (requiredFields.citizenship ? 1 : 0) + (requiredFields.documentNumber ? 1 : 0);
  const deduct =
    100 +
    150 +
    50 +
    (requiredFields.dateOfBirth ? 150 : 0) +
    (requiredFields.gender ? 150 : 0) +
    (requiredFields.documentExpiryDate ? 150 : 0);
  const width = (availableWidth - deduct - 64) / divideBy;
  return [
    { width: 100, resizable: false },
    getResizableColumn(width),
    { width: 50, resizable: false },
    { width: 150, resizable: false },
    getResizableColumn(width),
    getResizableColumn(width),
    requiredFields.dateOfBirth ? { width: 150, resizable: false } : null,
    requiredFields.gender ? { width: 150, resizable: false } : null,
    requiredFields.citizenship ? getResizableColumn(width) : null,
    requiredFields.documentNumber ? getResizableColumn(width) : null,
    requiredFields.documentExpiryDate ? { minWidth: 150, width: 150, resizable: false } : null,
  ]
    .filter((v) => !!v)
    .map((c, idx) => ({ ...c, colIndex: idx }));
}

function getResizableColumn(width: number): Omit<Column, "colIndex"> {
  const minWidth = width > 250 ? 250 : 150;
  return { minWidth, width, resizable: true };
}
